var _g, _defs;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 250,
    height: 250,
    viewBox: "0 0 250 250",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M125 250C194.036 250 250 194.036 250 125C250 55.9644 194.036 0 125 0C55.9644 0 0 55.9644 0 125C0 194.036 55.9644 250 125 250Z",
    fill: "#13C1BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.865 86.305C240.325 75.4225 235.345 65.1975 229.132 55.855L119.715 169.82L119.935 182.502L125.1 182.47L243.865 86.305Z",
    fill: "#37A18E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.186 49.2049L227.896 27.1824C224.853 24.1749 219.918 24.1749 216.876 27.1824L121.593 125.327L80.5033 84.7274C77.4558 81.7199 72.5258 81.7199 69.4808 84.7274L49.7233 104.25C46.6808 107.255 46.6808 112.13 49.7233 115.135L115.671 180.287C117.428 182.025 119.811 182.725 122.101 182.455C124.391 182.722 126.773 182.025 128.531 180.287L250.186 60.0924C253.228 57.0849 253.228 52.2124 250.186 49.2049Z",
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.536 180.287L250.191 60.0924C253.234 57.0849 253.234 52.2124 250.191 49.2049L246.554 45.6099L121.411 168.697L52.4911 101.517L49.7311 104.247C46.6886 107.252 46.6886 112.127 49.7311 115.132L115.676 180.287C117.434 182.025 119.816 182.725 122.106 182.455C124.396 182.725 126.779 182.027 128.536 180.287Z",
    fill: "#EBEBEB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 250,
    height: 250,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.d4e8a07c18eb94b21a071b17f322ec27.svg";
export { ForwardRef as ReactComponent };